import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Chip from 'components/atoms/Chip';
import { InputError } from 'components/atoms/styleds';

import { Wrapper } from './styled';

const ChipsList = ({
  name,
  list,
  selectedList,
  onClick,
  error,
  isColumn = false,
  onlyNative,
  disabledKeys = [],
  checkBorder ,
  gap,
}) => {
  return (
    <Wrapper gap={gap} isColumn={isColumn} onlyNative={onlyNative}>
      {list?.map((i) => (
        <div style={{ position: 'relative' }} key={i.id}>
          <Chip
            checkBorder={checkBorder}
            id={i.id}
            label={i.title}
            active={selectedList?.includes(i.id)}
            onClick={(e) => !i.disabled && onClick(i, name, e)}
            disabled={disabledKeys?.includes(i.id)}
            error={error || i.error}
            onlyNative={onlyNative}
          />
          {i.error && <InputError style={{ paddingLeft: 15 }}>{i.error}</InputError>}
          {i.additionalContent}
        </div>
      ))}
      {error && <InputError style={{ paddingLeft: 15 }}>{error}</InputError>}
    </Wrapper>
  );
};

ChipsList.propTypes = {
  name: PropTypes.string,
  list: PropTypes.array,
  selectedList: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  error: PropTypes.any,
  isColumn: PropTypes.bool,
  onlyNative: PropTypes.bool,
  disabledKeys: PropTypes.array,
};

export default ChipsList;
